<!--
 * @Description: 云途销售线索 - 详情页面
 * @Author: mdb
 * @Date: 2022-07-16 10:45:39
 * @LastEditTime: 2022-11-23 16:59:44
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="dataForm?.customerName"
        :sellerName="dataForm?.followerName"
        :collection-id="dataForm?.collectionId"
        customLabel="联系人姓名"
        :customValue="dataForm?.contact.name"
        :add-fav="addFavorite"
        :cancel-fav="cancelFavorite"
      >
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" tab="基本信息">
            <DetailForm ref="detailFormRef" type="view" :isEdit="false" v-model:value="dataForm"/>
          </a-tab-pane>
          <a-tab-pane key="contact" tab="联系人">
            <TabsContacts
              ref="contactsRef"
              appId="cos_lbu"
              :contactRefId="queryClueId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="record" tab="跟进记录">
            <TabsClueCosFollowUp :permissionPage="permissionFollow" appId="cos_lbu" :followRefId="queryClueId"/>
          </a-tab-pane>
          <a-tab-pane key="convert" tab="转化记录">
            <TabsConversion appId="cos_lbu" :resourceId="queryClueId"/>
          </a-tab-pane>
          <a-tab-pane key="logs" tab="操作日志">
            <TabsOperationLog
              ref="operationLogRef"
              appId="cos_lbu"
              tableId="LbuSalesClueOperationLog"
              :resourceId="queryClueId"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <template v-if="!isPublicClue">
        <SellerButton
          v-permission="'lbu_clue_edit_btn'"
          controlType="none"
          v-if="dataForm.clueStatus !== 8"
          @click="goToEdit()"
        >编辑
        </SellerButton
        >
        <a-button v-permission="permissionConcat.add" v-if="dataForm.clueStatus !== 8" @click="handleAddConcat()"
        >新增联系人
        </a-button
        >
        <SellerButton
          v-permission="'lbu_clue_potential_btn'"
          :workCode="dataForm.follower"
          controlType="none"
          v-if="dataForm.clueStatus !== 8"
          @click="handleTurnPotential()"
        >转为潜在客户
        </SellerButton
        >
        <a-button
          v-permission="'lbu_clue_write_follow_btn'"
          v-if="dataForm.clueStatus !== 8"
          type="primary"
          @click="handleWriteFollowUp()"
        >写跟进
        </a-button
        >
      </template>
    </cos-footer-button>
  </dc-layout-main>

  <!--新增联系人--->
  <ConcatModal ref="concatModalRef" @success="successAddConcat" :contactRefId="queryClueId"/>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import DetailForm from './components/DetailForm.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsConversion from '@/components/TabsConversion'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ConcatModal from '@/components/TabsContacts/lbu/editModal.vue'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import { addToFav, cancelToFav } from '@/api/common'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'

const router = useRouter()
const route = useRoute()

const queryClueId = computed(() => route.query.clueId as string)
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
const dataForm = reactive<LbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    saleInfo: [{}],
    demandInfo: [{}],
    erpInfo: [{}]
  },
  visitAddress: [{}]
})
const permissionFollow = {
  edit: 'lbu_clue_follow_edit_btn',
  del: 'lbu_clue_follow_del_btn'
}
const permissionConcat = {
  add: 'lbu_clue_contact_add_btn',
  edit: 'lbu_clue_contact_edit_btn',
  del: 'lbu_clue_contact_del_btn',
  isPublic: isPublicClue.value === '1'
}
const getDetails = () => {
  salesClueDetail({ clueId: queryClueId.value }).then((res) => {
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => getDetails())

const activeTabs = ref('info')
const operationLogRef = ref()
const handleTabsChange = (val: any) => {
  if (val === 'info') {
    getDetails()
  } else if (val === 'logs') {
    operationLogRef.value?.fetch()
  }
}

// 新增联系人
const contactsRef = ref()
const concatModalRef = ref()
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successAddConcat = (type: any) => {
  contactsRef.value?.refresh(type)
  operationLogRef.value?.fetch()
  getDetails()
}
// 跳转跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: queryClueId.value,
      returnPath: route.fullPath
    }
  })
}
const goToEdit = () => {
  router.push({
    path: '/lbu/salesClue/edit',
    query: { clueId: queryClueId.value }
  })
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_lbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = dataForm?.clueId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = null
      dataForm.collectionTime = null
    }
  })
}
const handleTurnPotential = (row = dataForm) => {
  if (!row) return
  if (row.clueStatus === 5) return message.warning('无效线索不能转潜在客户')
  router.push({
    path: '/lbu/salesClue/potential',
    query: { clueId: row.clueId }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesClueView' }
</script>

<style scoped></style>
